export function createMajorFormValidator(values) {
  const errors: any = {};
  if (!values.name?.trim()) {
    errors.name = "Name field is required";
  }

  return errors;
}
